import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-comisiones',
  templateUrl: './comisiones.component.html',
  styleUrls: ['./comisiones.component.css']
})
export class ComisionesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
